import { emailValidation } from "@asayinc/component-library";

function validateEmailAddress(email: string): boolean {
  const re = emailValidation;
  return re.test(String(email).toLowerCase());
}

export { validateEmailAddress };
